import { styled } from 'goober'

export const Section = styled('section')`
  padding: .2rem 1rem;
`
